/*!
 * EPScatter — Svelte 5 (runes mode) re-implementation of the scatter
 * "participación vs margen del ganador".
 *
 * Public API kept identical to the previous vanilla version so the CMS
 * embed code doesn't need to change:
 *
 *   EPScatter.mount({
 *     selector,
 *     dataUrl,
 *     namesUrl?,
 *     initialYear?,
 *     parties?          // { [shortName]: { color?, long? } } override map
 *   });
 *
 * Returns `{ destroy() }`.
 */
import { mount as svelteMount, unmount } from 'svelte';
import Chart from './Chart.svelte';
import './styles/ep-scatter.css';

export function mount(opts = {}) {
  if (!opts.selector) throw new Error('EPScatter.mount: selector is required');
  if (!opts.dataUrl) throw new Error('EPScatter.mount: dataUrl is required');

  const target =
    typeof opts.selector === 'string'
      ? document.querySelector(opts.selector)
      : opts.selector;
  if (!target) throw new Error('EPScatter.mount: selector did not match anything');

  const app = svelteMount(Chart, {
    target,
    props: {
      dataUrl: opts.dataUrl,
      namesUrl: opts.namesUrl ?? null,
      initialYear: opts.initialYear ?? null,
      parties: opts.parties ?? null
    }
  });

  return {
    destroy() {
      unmount(app);
    }
  };
}

export const version = '0.4.0';
